import { api } from "./_client";

// iter-108: hour-log API helpers.

export async function getHourLogConfig() {
    const { data } = await api.get("/hour-log/config");
    return data;
}

export async function updateHourLogConfig(patch) {
    const { data } = await api.put("/hour-log/config", patch);
    return data;
}

export async function listHourLogEmployees() {
    const { data } = await api.get("/hour-log/employees");
    return data.employees || [];
}

export async function createHourLogEmployee(body) {
    const { data } = await api.post("/hour-log/employees", body);
    return data;
}

export async function updateHourLogEmployee(id, patch) {
    const { data } = await api.patch(`/hour-log/employees/${id}`, patch);
    return data;
}

export async function deleteHourLogEmployee(id) {
    const { data } = await api.delete(`/hour-log/employees/${id}`);
    return data;
}

export async function listHourLogEntries({ date_from, date_to, employee_id } = {}) {
    const params = {};
    if (date_from) params.date_from = date_from;
    if (date_to) params.date_to = date_to;
    if (employee_id) params.employee_id = employee_id;
    const { data } = await api.get("/hour-log/entries", { params });
    return data.entries || [];
}

export async function createHourLogEntry(body) {
    const { data } = await api.post("/hour-log/entries", body);
    return data;
}

export async function updateHourLogEntry(id, patch) {
    const { data } = await api.patch(`/hour-log/entries/${id}`, patch);
    return data;
}

export async function deleteHourLogEntry(id) {
    const { data } = await api.delete(`/hour-log/entries/${id}`);
    return data;
}

export async function clockInSelf(body = {}) {
    const { data } = await api.post("/hour-log/clock-in", body);
    return data;
}

export async function clockOutSelf(body = {}) {
    const { data } = await api.post("/hour-log/clock-out", body);
    return data;
}

export async function clockInEmployee(empId, body = {}) {
    const { data } = await api.post(`/hour-log/employees/${empId}/clock-in`, body);
    return data;
}

export async function clockOutEmployee(empId, body = {}) {
    const { data } = await api.post(`/hour-log/employees/${empId}/clock-out`, body);
    return data;
}

export async function listPastPayPeriods() {
    const { data } = await api.get("/hour-log/past-periods");
    return data.periods || [];
}

export async function sendHourLogReportNow() {
    const { data } = await api.post("/hour-log/send-report-now");
    return data;
}
